import { render } from "./SubCabs.vue?vue&type=template&id=6f5c7087&scoped=true"
import script from "./SubCabs.vue?vue&type=script&lang=js"
export * from "./SubCabs.vue?vue&type=script&lang=js"

import "./SubCabs.vue?vue&type=style&index=0&id=6f5c7087&scoped=true&lang=css"
import "./SubCabs.vue?vue&type=style&index=1&id=6f5c7087&lang=css"

import exportComponent from "D:\\PRG\\gitEE\\wwj\\web\\htweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5c7087"]])

export default __exports__